import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { ApiError, AuthService, BaseForm, BaseFormService, ConfigService, MessageService } from '../../../../core';
import { ConfigEmpresa, isTipoMercadoMarca } from '../../../configuracoes/app/empresa';
import { origemLancamentoCadastroSogivendas } from '../../../../models/origem-lancamento-cadastro';
import { Representante } from '../representante';
import { representanteSituacoes } from '../situacao';
import { representanteTiposComissao } from '../representante-tipo-comissao';
import { RepresentanteCrudHttpService } from '../services';
import { PessoaContatoComponent, contatoTipoPrincipal } from '../../contato';
import { PessoaEnderecoUnicoComponent, enderecoTipoPrincipal } from '../../endereco';
import { pessoaTipoCadastro } from '../../pessoa-tipo-cadastro';
import { Usuario } from '../../../usuario/usuario';
import { RepresentanteValidacoesHttpService } from '../validacoes';
import { PessoaCrudHttpService } from '../../services';
// import { RepresentanteMarcaComponent } from '../marca';
// import { RepresentanteLinhaComponent } from '../linha';
import { RepresentanteVinculadoComponent } from '../vinculado';
import { RepresentanteGerenteComponent } from '../gerente';
import { RepresentanteAtendenteComponent } from '../atendente';
import { RepresentanteClassificacaoClienteFormComponent } from '../classificacao-cliente';

@Component({
    selector: 'sgt-representante-form',
    templateUrl: './representante-form.component.html',
    styleUrls: ['./representante-form.component.less']
})
export class RepresentanteFormComponent implements BaseForm<Representante>, OnInit {
    configEmpresa: ConfigEmpresa;
    isAdministrador: boolean;

    entity: Representante;
    editMode: boolean;
    tipoCadastro = pessoaTipoCadastro.representante;
    @ViewChild('form') form: NgForm;

    // Contatos
    contatoPrincipal = contatoTipoPrincipal.id;
    @ViewChild('pessoaOutrosContatosCadastro') pessoaOutrosContatosCadastro: PessoaContatoComponent;
    // Endereço
    enderecoPrincipal = enderecoTipoPrincipal.id;
    @ViewChild('pessoaEnderecoPrincipal') pessoaEnderecoPrincipal: PessoaEnderecoUnicoComponent;
    // Marcas
    // @ViewChild('marcaCadastro') marcaCadastro: RepresentanteMarcaComponent;
    // Marcas
    // @ViewChild('linhaCadastro') linhaCadastro: RepresentanteLinhaComponent;
    // Representantes Vinculados
    @ViewChild('representanteVinculadoCadastro') representanteVinculadoCadastro: RepresentanteVinculadoComponent;
    // Gerentes
    @ViewChild('gerenteCadastro') gerenteCadastro: RepresentanteGerenteComponent;
    // Atendentes
    @ViewChild('atendenteCadastro') atendenteCadastro: RepresentanteAtendenteComponent;

    /** Form das classificações de clientes */
    @ViewChild('classificacaoClienteForm') classificacaoClienteForm: RepresentanteClassificacaoClienteFormComponent;

    situacoes = representanteSituacoes;
    tiposComissao = representanteTiposComissao;

    constructor(private activatedRoute: ActivatedRoute,
                private router: Router,
                private authService: AuthService,
                private messageService: MessageService,
                private baseFormService: BaseFormService,
                private configService: ConfigService,
                private representanteCrudHttpService: RepresentanteCrudHttpService,
                private representanteValidacoesHttpService: RepresentanteValidacoesHttpService,
                private pessoaCrudHttpService: PessoaCrudHttpService) { }

    ngOnInit() {
        this.configEmpresa = this.configService.getEmpresa();
        this.isAdministrador = this.authService.isAdministrador();

        this.baseFormService.getIdParam(this.activatedRoute).then(id => {
            if (!id) {
                // this.insert();
                this.cancel();
            } else {
                this.edit(id);
            }
        });
    }

    /** Verifica se o Tipo de Mercado da empresa é por Marca */
    isTipoMercadoMarca(): boolean {
        if (!this.configEmpresa) {
            return false;
        }
        return isTipoMercadoMarca(this.configEmpresa.tipoMercado);
    }

    load(id: number) {
        this.representanteCrudHttpService.load(id)
            .subscribe(
                entity => this.entity = entity,
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao carregar o representante', error);
                    this.cancel();
                }
            );
    }

    insert() {
        this.editMode = false;
        this.entity = new Representante(origemLancamentoCadastroSogivendas);
        this.entity.pessoa.idEmpresa = this.authService.getIdEmpresa();

        this.afterInsert();
    }

    private afterInsert() {
        // Setando a cidade e país no endereço principal
        setTimeout(() => {
            if (this.pessoaEnderecoPrincipal) {
                this.pessoaEnderecoPrincipal.setCidadeEPais();
            }
        }, 300);

        // Classificações de Clientes
        setTimeout(() => this.classificacaoClienteForm?.insert(), 0);
    }

    edit(id: number) {
        this.editMode = true;
        this.load(id);
    }

    /** Valida se pode realizar o save */
    private validateSave(): boolean {
        // Contatos
        if (this.pessoaOutrosContatosCadastro.isFormOpen) {
            this.messageService.info('Salve ou cancele o contato para salvar o representante', 'Informação');
            this.baseFormService.showTabForm('#tabContatos');
            return false;
        }
        // Endereço
        if (!this.pessoaEnderecoPrincipal.isValid()) {
            this.baseFormService.showTabForm('#tabEnderecos');
            return false;
        }
        // Marcas
        // if (this.isTipoMercadoMarca() && !this.marcaCadastro.isValid()) {
        //     this.baseFormService.showTabForm('#tabMarcas');
        //     return false;
        // }
        // Linhas
        // if (this.linhaCadastro && !this.linhaCadastro.isValid()) {
        //     this.baseFormService.showTabForm('#taLinhas');
        //     return false;
        // }

        // Classificações de Clientes
        if (this.classificacaoClienteForm && !this.classificacaoClienteForm.isValid()) {
            this.baseFormService.showTabForm('#tabClassificacoesClientes');
            return false;
        }

       // Representantes Vinculados
       if (this.representanteVinculadoCadastro && !this.representanteVinculadoCadastro.isValid()) {
            this.baseFormService.showTabForm('#tabRepresentantesVinculados');
            return false;
        }
        // Gerentes
        if (this.gerenteCadastro && !this.gerenteCadastro.isValid()) {
            this.baseFormService.showTabForm('#tabGerentes');
            return false;
        }
        // Atendentes
        if (this.atendenteCadastro && !this.atendenteCadastro.isValid()) {
            this.baseFormService.showTabForm('#tabAtendentes');
            return false;
        }


        return true;
    }

    private beforeSave() {
        // Marcas
        // if (this.isTipoMercadoMarca()) {
        //     this.marcaCadastro.resolve();
        // }
        // Linhas
        // if (this.linhaCadastro) {
        //     this.linhaCadastro.resolve();
        // }
        // Representantes Vinculados
        if (this.representanteVinculadoCadastro) {
            this.representanteVinculadoCadastro.resolve();
        }
        // Gerentes
        if (this.gerenteCadastro) {
            this.gerenteCadastro.resolve();
        }
        // Atendentes
        if (this.atendenteCadastro) {
            this.atendenteCadastro.resolve();
        }
    }

    save() {
        if (this.validateSave()) {
            this.beforeSave();
            this.baseFormService.save<Representante>(this.entity, this.form, this.editMode, this.representanteCrudHttpService)
                .then(entity => {
                    this.messageService.success('', 'Representante salvo com sucesso');
                    this.afterSave(entity);
                })
                .catch(error => {});
        }
    }

    afterSave(entity: Representante) {
        this.cancel();
    }

    cancel() {
        this.baseFormService.cancel(this.activatedRoute);
    }

    /** Ao alterar o usuário gerente no typeahead */
    onTypeaheadChangeUsuarioGerente(usuarioGerente: Usuario) {
        if (usuarioGerente) {
            this.entity.idUsuarioGerente = usuarioGerente.id;
        } else {
            this.entity.idUsuarioGerente = null;
        }
    }

    /** Ao alterar o usuário atendente no typeahead */
    onTypeaheadChangeUsuarioAtendente(usuarioAtendente: Usuario) {
        if (usuarioAtendente) {
            this.entity.idUsuarioAtendente = usuarioAtendente.id;
        } else {
            this.entity.idUsuarioAtendente = null;
        }
    }

    /** Realiza a validação de cadastro já existe do representante e pessoa através do CNPJ/CPF informado */
    onValidarCnpjCpfCadastrado() {
        if (!this.entity && !this.entity.pessoa) {
            return;
        }

        const idPessoa = this.entity.pessoa.id && !isNaN(this.entity.pessoa.id) ? Number(this.entity.pessoa.id) : 0;
        this.representanteValidacoesHttpService.getRepresentanteJaCadastrado(idPessoa, this.entity.pessoa.cnpjCpf)
            .subscribe(
                validacao => {
                    // 1 - Verificando se o Representante já está cadastrado
                    if (validacao.jaCadastrado) {
                        this.messageService.confirm('Já existe um representante cadastrado com este CNPJ/CPF informado. Deseja carregar os seus dados?', 'Confirme').then((result) => {
                            if (result) {
                                // Navegando para o cadastrado do representante para entrar em modo de edição
                                this.router.navigate(['../', validacao.id], {relativeTo: this.activatedRoute});

                                // Quando estiver editiando, precisamos recarregar a página por causa que o route fica igual (mudando apenas o ID)
                                if (this.editMode) {
                                    location.reload();
                                }
                            }
                        });
                    } else {
                        // 2 - Verificando se a pessoa já está cadastrada
                        if (validacao.pessoaJaCadastrada) {
                            this.messageService.confirm('Já existe um cadastrado com este CNPJ/CPF informado. Desejar carregar os seus dados?', 'Confirme').then((result) => {
                                if (result) {
                                    // Carregando os dados da pessoa
                                    this.pessoaCrudHttpService.load(validacao.idPessoa)
                                        .subscribe(
                                            entityPessoa => this.entity.pessoa = entityPessoa,
                                            (error: ApiError) => this.messageService.error(error.message, 'Ocorreu um erro ao carregar os dados', error)
                                        );
                                }
                            });
                        }
                    }
                },
                (error: ApiError) => this.messageService.error(error.message, 'Ocorreu um erro ao verificar se o já existe um representante com o CNPJ/CPF cadastrado', error)
            );
    }
}
